var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.097 18.4813L15.1961 14.0629H16.6917C17.1316 14.0629 17.5208 13.8187 17.7063 13.4252C17.8919 13.0326 17.8308 12.5824 17.5462 12.2509L13.7312 7.81287H15.1419C15.5862 7.81287 15.9866 7.55164 16.1604 7.14832C16.3323 6.75134 16.2512 6.28943 15.9534 5.97253L10.5691 0.236206C10.2747 -0.0787354 9.72537 -0.0787354 9.43045 0.236206L4.04568 5.97253C3.74783 6.28943 3.66726 6.75134 3.83865 7.14832C4.01248 7.55164 4.41336 7.81287 4.85769 7.81287H6.26834L2.45291 12.2518C2.16922 12.5829 2.10818 13.0326 2.29324 13.4257C2.47879 13.8187 2.86746 14.0629 3.30789 14.0629H4.80349L0.902615 18.4813C0.609646 18.8129 0.54324 19.267 0.728787 19.6659C0.911892 20.059 1.31472 20.3129 1.75467 20.3129H8.43728V21.5067L6.95828 23.87C6.69851 24.3895 7.07644 25.0009 7.65701 25.0009H12.3426C12.9231 25.0009 13.3011 24.3895 13.0413 23.87L11.5623 21.5067V20.3129H18.2449C18.6848 20.3129 19.0877 20.059 19.2708 19.6659C19.4563 19.267 19.3899 18.8129 19.097 18.4813Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/Tree.fb054c5589363114c779762df62f7c29.svg";
export { ForwardRef as ReactComponent };